import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanelModule } from 'primeng/panel';
import { LiftBreakdownWidget } from '../../models/loyalty-dashboard.model';

@Component({
  selector: 'app-lift-breakdown-widget',
  standalone: true,
  imports: [CommonModule, PanelModule],
  template: `
    <p-panel header="Where the lift came from">
      <div class="lift-breakdown" *ngIf="data as widget; else noData">
        <div class="lift-breakdown__row" *ngFor="let item of widget.components">
          <div class="lift-breakdown__head">
            <span class="lift-breakdown__label">{{ item.label }}</span>
            <span class="lift-breakdown__amount">{{ item.amount | currency : 'USD' : 'symbol' : '1.0-0' }}</span>
          </div>
          <div class="lift-breakdown__track">
            <div class="lift-breakdown__fill" [style.width.%]="share(item.amount, widget)"></div>
          </div>
        </div>
        <p class="lift-breakdown__note" *ngIf="widget.note">{{ widget.note }}</p>
      </div>
      <ng-template #noData>
        <p class="lift-breakdown__empty">No data available.</p>
      </ng-template>
    </p-panel>
  `,
  styles: [
    `
      .lift-breakdown {
        display: flex;
        flex-direction: column;
        gap: 1.1rem;
      }
      .lift-breakdown__head {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        gap: 1rem;
        margin-bottom: 0.4rem;
      }
      .lift-breakdown__label {
        font-size: 1rem;
      }
      .lift-breakdown__amount {
        font-weight: 700;
        white-space: nowrap;
      }
      .lift-breakdown__track {
        height: 0.5rem;
        border-radius: 999px;
        background: var(--surface-200, #e9ecef);
        overflow: hidden;
      }
      .lift-breakdown__fill {
        height: 100%;
        border-radius: 999px;
        background: var(--primary-color, #2563eb);
        transition: width 0.3s ease;
      }
      .lift-breakdown__note {
        margin: 0.3rem 0 0;
        font-size: 0.8rem;
        opacity: 0.6;
      }
    `,
  ],
})
export class LiftBreakdownWidgetComponent {
  @Input() data: LiftBreakdownWidget | null = null;

  /** Bar width as a percentage: this component's share of the total positive lift. */
  share(amount: number, widget: LiftBreakdownWidget): number {
    const total = widget.components.reduce((sum, c) => sum + Math.max(0, c.amount), 0);
    if (total <= 0) {
      return 0;
    }
    return Math.max(0, Math.min(100, (amount / total) * 100));
  }
}
